import {
  DiscussionTargetType,
  TargetCandidate,
} from '../../../../../domain/entity/DiscussionEntity'

export type FilterOption = {
  value: string
  label: string
}

export type FilterTypeKey = 'target'

export type FilterTypeConfig = {
  key: FilterTypeKey
  getLabelId: (candidates: TargetCandidate[]) => string
  getPlaceholderId: (candidates: TargetCandidate[]) => string
  getOptions: (candidates: TargetCandidate[]) => FilterOption[]
  isAvailable: (candidates: TargetCandidate[]) => boolean
}

const inferTargetType = (
  candidates: TargetCandidate[]
): DiscussionTargetType | null => {
  if (candidates.length === 0) return null
  return candidates[0].type
}

export const FILTER_TYPES: FilterTypeConfig[] = [
  {
    key: 'target',
    getLabelId: candidates =>
      inferTargetType(candidates) === 'TEAM'
        ? 'discussion.filter.type.team'
        : 'discussion.filter.type.process',
    getPlaceholderId: candidates =>
      inferTargetType(candidates) === 'TEAM'
        ? 'discussion.filter.search.team'
        : 'discussion.filter.search.process',
    getOptions: candidates =>
      candidates.map(c => ({ value: c.uuid, label: c.name })),
    isAvailable: candidates => candidates.length > 0,
  },
]
